import React from 'react';
import CloseButton, {CloseButtonProps} from '../CloseButton';

export default function PopupCloseButton({style, ...props}: CloseButtonProps) {
    return <CloseButton
        style={{top: -10, right: -10, position: 'absolute', ...style}}
        {...props}
    />;
}
